import { TripSheetProps } from '../datastore/tripSheets';

export type ObserveTripSheetsMode = 'full' | 'admin-panel';

export const projectTripSheetForMode = (tripSheet: TripSheetProps, mode: ObserveTripSheetsMode): TripSheetProps => {
  if (mode !== 'admin-panel') {
    return tripSheet;
  }

  return {
    id: tripSheet.id,
    reference: tripSheet.reference,
    createdAt: tripSheet.createdAt,
    carrier: tripSheet.carrier,
    legs: tripSheet.legs.map((leg) => ({
      id: leg.id,
      status: leg.status,
      origin: leg.origin,
      destination: leg.destination,
      departureDate: leg.departureDate,
      arrivalDate: leg.arrivalDate,
      manifests: leg.manifests.map((manifest) => ({
        id: manifest.id,
        status: manifest.status,
        tripId: manifest.tripId,
        trailerId: manifest.trailerId,
        ssccs: manifest.ssccs.map((sscc) => ({
          ssccId: sscc.ssccId,
          totalWeight: sscc.totalWeight,
          packages: (sscc.packages || []).map((pkg) => ({
            id: pkg.id,
            asn: pkg.asn,
            poNumber: pkg.poNumber,
            receivedStatus: pkg.receivedStatus,
            quantity: pkg.quantity,
            maxQuantity: pkg.maxQuantity,
            packageType: pkg.packageType,
            height: pkg.height,
            width: pkg.width,
            depth: pkg.depth,
            inventoryLines: []
          })),
          receiptedEvents: (sscc.receiptedEvents || []).map((event) => ({
            name: event.name,
            site: event.site,
            packages: (event.packages || []).map((pkg) => ({
              id: pkg.id,
              asn: pkg.asn,
              po: pkg.po,
              status: pkg.status,
              priority: pkg.priority,
              packageType: pkg.packageType,
              height: pkg.height,
              width: pkg.width,
              depth: pkg.depth,
              weight: pkg.weight,
              statusDate: pkg.statusDate,
              jobId: pkg.jobId,
              assetNumber: pkg.assetNumber,
              supplierName: pkg.supplierName,
              supplierId: pkg.supplierId,
              quantity: pkg.quantity,
              companyName: pkg.companyName,
              hasDangerousGoods: pkg.hasDangerousGoods,
              dateReceived: pkg.dateReceived,
              docketNumber: pkg.docketNumber,
              qrCodeId: pkg.qrCodeId,
              shipToAttention: pkg.shipToAttention,
              items: []
            }))
          }))
        }))
      }))
    }))
  };
};
